import {
  COMPANY_LOADING,
  COMPANY_USER_EDITED,
  COMPANY_USER_LOADED,
  COMPANY_USER_FAILED,
  COMPANY_USER_ADDED,
  AUTH_FAILED,
  LOGOUT,
} from "../types";

import { created, editedUpdate } from "../../helpers/reduxUtils";

const initiateState = {
  loading: false,
  users: [],
};

export default function (state = initiateState, action) {
  switch (action.type) {
    case COMPANY_USER_LOADED:
      return {
        ...state,
        loading: false,
        users: action.payload,
      };
    case COMPANY_USER_EDITED:
      return {
        ...state,
        loading: false,
        users: editedUpdate(state.users, action.payload),
      };
    case COMPANY_USER_ADDED:
      return {
        ...state,
        loading: false,
        users: created(state.users, action.payload),
      };
    case COMPANY_LOADING:
      return {
        ...state,
        loading: true,
      };
    case COMPANY_USER_FAILED:
      return {
        ...state,
        loading: false,
      };
    case LOGOUT:
    case AUTH_FAILED:
      return initiateState;
    default:
      return state;
  }
}
